import type { QuestionAnswerValue } from './QuestionRenderer';

/** Scalar for logic / navigation maps (matrix rows are stored separately). */
export function matrixAnswerToMapScalar(
  matrix: Record<string, number | 'NA'>
): string | number | null {
  const values = Object.values(matrix);
  if (values.length === 0) return null;

  for (const v of values) {
    if (typeof v === 'number' && !Number.isNaN(v)) return v;
  }
  if (values.every((v) => v === 'NA')) return 'NA';
  return values[0] ?? null;
}

export function answerValueToMapEntry(
  ans: QuestionAnswerValue
): string | number | boolean | null {
  if (ans.is_na) return 'NA';
  if (ans.answer_numeric != null) return ans.answer_numeric;
  if (ans.answer_text != null) return ans.answer_text;
  if (ans.answer_matrix && Object.keys(ans.answer_matrix).length > 0) {
    return matrixAnswerToMapScalar(ans.answer_matrix);
  }
  if (Array.isArray(ans.answer_values) && ans.answer_values.length > 0) {
    return ans.answer_values[0];
  }
  return null;
}
